import { Navigate } from 'react-router-dom';
import { Spinner, Pane } from 'evergreen-ui';
import { useAuth } from '../services/authContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <Pane display="flex" justifyContent="center" alignItems="center" height="60vh">
        <Spinner size={32} />
      </Pane>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;